"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFooter = void 0;
var tslib_1 = require("tslib");
var asg_1 = require("@alinta-digital/asg");
var react_1 = tslib_1.__importDefault(require("react"));
var PageFooter = function (_a) {
    var initialLoad = _a.initialLoad;
    return (react_1.default.createElement(react_1.default.Fragment, null, initialLoad ? (react_1.default.createElement(asg_1.Box, { pad: { vertical: 'xsmall' }, "data-testid": "bubbleBottomSkeleton" })) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(asg_1.Box, { pad: { vertical: 'medium' } })))));
};
exports.PageFooter = PageFooter;
//# sourceMappingURL=PageFooter.js.map